export default "__VITE_ASSET__B0KgKEac__"